import { ArrowRight } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * 新着求人一覧画面 メールマガジンリンク
 */
export const MailMagazineLink: React.FC = () => {
  return (
    <div className={styles.mailMagazineLink}>
      <a href="/mailmaga/intro.html" className={styles.textLink}>
        メールマガジン（無料）で効率的に新着求人情報を取得する
      </a>
      <div className={styles.mailMagazineLink_ArrowRight}>
        <ArrowRight size="S" color="blue" />
      </div>
    </div>
  );
};
